<template>
  <div class="page-container">
    <van-nav-bar fixed left-arrow title="积分商城" :z-index="10">
      <template #left>
        <div class="nav-left-bg">
          <span style="padding: 0 5px 0 0; height: 100%" @click="goableBack()">
            <van-icon name="arrow-left" color="black" size="16" />
          </span>
          <span style="font-size: 16px; font-weight: 900" @click="$router.push({ path: '/home' })">主页</span>
        </div>
      </template>
    </van-nav-bar>
    <div class="contain-bg" v-if="active == 0">
      <div class="list-contain-mall">
        <van-tabs :class="mallCategory ? 'normal-tabs' : 'select-tabs'" style="margin-top:0" v-model="mallType" animated swipeable :offset-top="45" :sticky="true" :title-active-color="
            mallCategory ? 'rgba(0,0,0)' : 'rgba(246, 66, 46)'
          " title-inactive-color="rgba(0,0,0)" line-width="20" line-height="5" @change="handleTabChange" @click="clickTabChange" :border="false">
          <van-tab v-for="(item, index) in columns" :key="item.id" :title="item.name" :name="item.id">
            <template #title>
              <div style="display: flex;justify-content: center;height: 100%;position: relative;">
                <div class="item-bg" style="
                  margin: px 0;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                ">
                  <div style="font-weight: bold;">
                    {{ item.name }}
                  </div>
                  <div v-if="mallCategory" style="font-size: 11px; margin-top: -5px;color: rgb(51, 51, 51);">
                    {{ item.typeDesc }}
                  </div>
                  <div v-else style="font-size: 11px; margin-top: -5px;color: rgb(51, 51, 51);" :style="mallType == item.id ? 'color:rgba(246, 66, 46, 0.8)' : 'rgb(51, 51, 51)'">
                    {{ item.typeDesc }}
                  </div>
                </div>
                <van-image v-show="item.imgPath" style="position: absolute; top: 6px;left: calc(50% + 15px)" class="icon-bg" fit="fill" width="20px" height="10px" :src="item.imgPath" />
              </div>
              <div v-show="index < columns.length-1" style="position: absolute;right: 0;top: calc(50% - 10px);color: rgb(222, 222, 222);">/</div>
            </template>
            <div class="container">
              <integral-mall-list :itemObj="item" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 选中首页视图 -->
    <div class="contain-bg" v-else-if="active == 1">
      <div class="member-top">
        <div class="member-info">
          <div class="member-info-left">
            <div class="memberGrade">
              <img class="memberGrade-img" :src="userInfo.logo" fit="cover" alt="会员等级" />
            </div>
            <div class="left1">{{ userInfo.custName }}</div>
            <div class="left2">总积分：{{ userInfo.sumScore || 0 }}</div>
          </div>
          <div class="member-info-right">
            <div class="right1">会员服务升级</div>
            <div class="right2">
              <span class="right2-1">尊享全新</span>
              <span class="right2-2">会员服务</span>
            </div>
          </div>
        </div>
      </div>
      <div class="member-bottom">
        <div class="center-title">会员权益</div>
        <div class="center-contain">
          <ul>
            <li v-for="item of rightsList" :key="item.id">
              <div class="item-contain" @click="clickMemberItem(item)">
                <div class="item-text-bg">
                  <div class="item-title">{{ item.title }}</div>
                  <div class="item-content">{{ item.subTitle }}</div>
                </div>
                <img class="item-icon" v-if="
                    item.imgUrl.indexOf('https://') > -1 ||
                    item.imgUrl.indexOf('http://') > -1
                  " :src="item.imgUrl" alt="" />
                <img class="item-icon" v-else src="item.imgUrl" alt="" />
              </div>
            </li>
          </ul>
          <!-- 清除浮动 -->
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 选中我的视图 -->
    <div class="contain-bg" v-else-if="active == 2">
      <div class="my-top">
        <div class="my-left">
          <div class="left1">{{ userInfo.custName }}</div>
          <div class="my-memberGrade">
            <img class="my-memberGrade-img" :src="userInfo.logo" fit="cover" alt="会员等级" />
          </div>
        </div>
        <div class="my-right">
          <div class="right-title">可用积分</div>
          <div class="right-value">{{ userInfo.sumScore || 0 }}</div>
        </div>
      </div>
      <div class="list-contain">
        <van-list class="my-list">
          <van-cell class="my-cell" v-for="item in myList" :key="item.title" :title="item.title" is-link @click="clickMyList(item)"></van-cell>
        </van-list>
      </div>
    </div>
    <!-- 底部导航视图 -->
    <div class="tabBar">
      <van-tabbar v-model="active" @change="onChange" active-color="rgb(220, 186, 122)" inactive-color="rgb(192, 195, 195)" fixed>
        <van-tabbar-item icon="home-o">
          商城首页
          <template #icon="">
            <img v-if="active == 0" src="../../../assets/img/memberIntegral/mi_mall_select_icon.jpg" />
            <img v-else src="../../../assets/img/memberIntegral/mi_mall_normal_icon.jpg" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item icon="home-o">
          会员中心
          <template #icon="">
            <img v-if="active == 1" src="../../../assets/img/memberIntegral/mi_member_select_icon.jpg" />
            <img v-else src="../../../assets/img/memberIntegral/mi_member_normal_icon.jpg" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item icon="chat-o">
          我的
          <template #icon="">
            <img v-if="active == 2" src="../../../assets/img/memberIntegral/mi_my_select_icon.png" />
            <img v-else src="../../../assets/img/memberIntegral/mi_my_normal_icon.png" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import {
  Cell,
  Icon,
  Image,
  List,
  Sticky,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs
} from "vant"
import session from "../../../utils/session"
import { goodsClassifiesList } from "../../../api/mall"
import IntegralMallList from "./components/integralMallList.vue"
import { mapActions, mapGetters, mapMutations } from "vuex"
import * as MemberIntegralApi from "@/api/memberIntegral"
export default {
  name: "integralMall",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [List.name]: List,
    [Cell.name]: Cell,
    IntegralMallList,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Image.name]: Image,
    [Sticky.name]: Sticky
  },
  data() {
    return {
      active: 0,
      rightsList: [], //会员权益集合
      myList: [
        { title: "全部订单", type: "1" },
        { title: "我的兑换", type: "2" },
        { title: "积分明细", type: "3" },
        { title: "地址管理", type: "5" },
        { title: "支付密码设置", type: "4" }
      ], //我的列表
      mallType: "",
      temMallCategory: "",
      columns: []
    }
  },
  computed: {
    ...mapGetters(["mallCategory"])
  },
  mounted() {
    this.getVipRights()
    this.getUserInfo()

    goodsClassifiesList()
      .then((data) => {
        this.columns = data
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  created() {
    this.active = sessionStorage.getItem("memberMallActive") | 0

    if (session.get("mall-tab-select")) {
      this.mallType = Number(session.get("mall-tab-select"))
      session.del("mall-tab-select")
    }
  },
  watch: {
    active: function (newValue, oldValue) {
      sessionStorage.setItem("memberMallActive", newValue)
    }
  },
  methods: {
    ...mapMutations(["setMallCategory"]),
    handleTabChange(index) {
      this.mallType = index
      session.set("mall-tab-select", index)
    },
    clickTabChange(index) {
      session.set("mall-tab-select", index)
      this.mallType = index
      if (index != this.temMallCategory) {
        this.temMallCategory = index
        this.setMallCategory(false)
      } else {
        if (this.mallCategory) {
          this.setMallCategory(false)
        } else {
          this.mallType = ""
          this.setMallCategory(true)
        }
      }
    },
    onBack() {
      this.goableBack()
      sessionStorage.removeItem("memberMallActive")
    },
    ...mapActions(["getUserInfo"]),
    //获取会员权益列表
    getVipRights() {
      MemberIntegralApi.getVipRights()
        .then((data) => {
          if (data) {
            this.rightsList = data
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    //会员权益点击事件
    clickMemberItem(item) {
      switch (item.type) {
        case 1:
          this.$router.push({
            name: "everySigin",
            params: {
              descTitle: item.descTitle,
              descriptions: item.descriptions
            }
          })
          break
        case 2:
          this.$router.push({ name: "myIntegral" })
          break
        case 3:
          this.$router.push({
            name: "subscriptionCourtesy",
            params: {
              descTitle: item.descTitle,
              descriptions: item.descriptions
            }
          })
          break
        case 4:
          this.$router.push({
            name: "birthdayTreat",
            params: {
              descTitle: item.descTitle,
              descriptions: item.descriptions
            }
          })
          break
        default:
          this.$toast("敬请期待！")
          break
      }
    },
    //点击我的列表
    clickMyList(item) {
      switch (item.type) {
        case "1":
          this.$router.push({ name: "allorder" })
          break
        case "2":
          this.$router.push({ name: "myExchange" })
          break
        case "3":
          this.$router.push({ name: "myIntegral" })
          break
        case "4":
          this.$router.push({ name: "settingPwd" })
          break
        case "5":
          this.$router.push({
            name: "myaddress"
          })
          break
        default:
          this.$toast("敬请期待！")
          break
      }
    },
    onChange(index) {
      this.active = index
      if (index == 0) {
        this.mallType = ""
        this.temMallCategory = ""
        this.setMallCategory(true)
      }
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .van-tabs__nav--line {
  padding-bottom: 0;
}
::v-deep .van-tab__text,
.van-tab__text--ellipsis {
  height: 100%;
  width: 100%;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 60px;
}
.normal-tabs {
  position: relative;
  ::v-deep .van-tabs__line {
    background-color: transparent;
    bottom: 10px;
  }
}
.select-tabs {
  position: relative;
  ::v-deep .van-tabs__line {
    background-color: rgb(246, 66, 46);
    bottom: 10px;
  }
}

//首页布局
.contain-bg {
  margin-bottom: 55px;
}
.list-contain-mall {
  overflow: hidden;
  .score-bg {
    height: 44px;
    margin-bottom: 4px;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    top: 46px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: white;
    .score-title-bg {
      margin: 0;
      color: rgb(102, 102, 102);
      font-size: 13px;
      padding: 0px 15px;
      background-color: white;
      .score {
        color: red;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .container {
    overflow: hidden;
    height: 100%;
  }
}
.member-top {
  background-image: url(../../../assets/img/memberIntegral/mi_center_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // Firefox4.0-
  -moz-box-shadow: 2px 2px 10px rgb(212, 214, 211);
  // Safariand Google chrome10.0-
  -webkit-box-shadow: 2px 2px 10px rgb(212, 214, 211);
  // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
  box-shadow: 2px 2px 10px rgb(212, 214, 211);
  .member-info {
    // background-color: rgb(247, 235, 201);
    margin: 15px;
    display: flex;
    justify-content: space-between;
    justify-items: center;
    padding: 20px 15px;
    padding-bottom: 60px;
    .member-info-left {
      .memberGrade {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 185 * 0.45px;
        height: 64 * 0.45px;
        margin-left: 5px;
        .memberGrade-img {
          width: 100%;
          height: 100%;
        }
      }
      .left1 {
        color: black;
        font-size: 20px;
        font-weight: 900;
        margin-top: 15px;
      }
      .left2 {
        color: rgb(156, 105, 34);
        font-size: 14px;
        margin-top: 5px;
      }
    }
    .member-info-right {
      .right1 {
        color: black;
        font-size: 28px;
        font-weight: 900;
        margin-top: -5px;
        margin-bottom: 10px;
        letter-spacing: 2px;
      }
      .right2-1 {
        color: black;
        font-size: 17px;
      }
      .right2-2 {
        color: rgb(156, 50, 28);
        font-size: 17px;
      }
    }
  }
}
.member-bottom {
  background-color: white;
  .center-title {
    color: black;
    font-size: 20px;
    padding: 10px 20px;
  }
  .item-title {
    color: black;
    font-size: 16px;
    font-weight: 500;
  }
  .item-content {
    color: rgb(147, 149, 149);
    font-size: 14px;
    margin-top: 5px;
  }
  .item-icon {
    height: 40px;
    width: 40px;
    margin-right: 5px;
    object-fit: cover;
  }
  .center-contain {
    .clear {
      clear: both;
      padding-bottom: 15px;
    }
    .item-text-bg {
      margin: 20px 10px;
    }
    .item-contain {
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: space-between;
      border-radius: 10px;
      // Firefox4.0-
      -moz-box-shadow: 2px 2px 10px rgb(226, 226, 218);
      // Safariand Google chrome10.0-
      -webkit-box-shadow: 2px 2px 10px rgb(226, 226, 218);
      // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
      box-shadow: 2px 2px 10px rgb(226, 226, 218);
    }
  }
  .center-contain ul {
    padding: 0 7.5px;
  }
  .center-contain ul li {
    border-radius: 10px;
    float: left;
    box-sizing: border-box;
    width: calc(50% - 15px);
    margin: 7.5px;
  }
}
//我的布局
.contain-bg {
  .my-top {
    background-image: url(../../../assets/img/memberIntegral/mi_mineMember_bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    .my-left {
      margin: 50px 0;
      .left1 {
        color: white;
        font-size: 18px;
        font-weight: 500;
      }
      .my-memberGrade {
        width: 185 * 0.45px;
        height: 64 * 0.45px;
        margin-top: 10px;
        .my-memberGrade-img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .my-right {
      margin: 50px 0;
      .right-title {
        color: white;
        font-size: 18px;
        font-weight: 500;
      }
      .right-value {
        color: white;
        font-size: 18px;
        font-weight: 500;
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  .list-contain {
    background-color: white;
    margin: 15px;
    border-radius: 10px;
    // Firefox4.0-
    -moz-box-shadow: 2px 2px 10px rgb(226, 226, 218);
    // Safariand Google chrome10.0-
    -webkit-box-shadow: 2px 2px 10px rgb(226, 226, 218);
    // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
    box-shadow: 2px 2px 10px rgb(226, 226, 218);
    .my-list {
      border-radius: 10px;
      .my-cell {
        color: rgb(77, 83, 84);
        border-radius: 10px;
      }
    }
  }
}
</style>